<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="col-md-4">
              <FormCotizacion />
            </div>
            <div class="col-md-8">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormCotizacion from "./components/FormCotizacion";

export default {
  components: {
    FormCotizacion,
  },
};
</script>